export default function sortTourneeModele(tourneeLigne) {
  tourneeLigne.sort((a, b) => {
    if (a.emplacementLibelle.localeCompare(b.emplacementLibelle) > 0) return 1;
    if (a.emplacementLibelle.localeCompare(b.emplacementLibelle) === 0) {
      if (a.dispositifLibelle.localeCompare(b.dispositifLibelle) > 0) return 1;
      if (a.dispositifLibelle.localeCompare(b.dispositifLibelle) === 0) {
        if (a.materielLibelle.localeCompare(b.materielLibelle) > 0) return 1;
        if (a.materielLibelle.localeCompare(b.materielLibelle) === 0) {
          return a.face.localeCompare(b.face);
        }
        return -1;
      }
      return -1;
    }
    return -1;
  });
}
